export const items = [
  [
    {
      name: 'About Us',
      icon: '/UserActivity.svg',
      link: '/about'
    },
    {
      name: 'News',
      icon: '/News.svg',
      link: '/news'
    },
    {
      name: 'Blog',
      icon: '/CloudUpload.svg',
      link: '/blog'
    },
     {
      name: "Events",
      icon: '/UserActivity.svg',
      link: '/events'
    },
    {
      name: 'Contact',
      icon: '/ComplianceTracking.svg',
      link: '/contact'
    },
    {
      name: 'Resources',
      icon: '/Playbooks.svg',
      link: '/resources'
    }
    ,
    //   {
    //   name: 'Legal',
    //   icon: '/Reports.svg',
    //   link: '/legal'
    // }
  ]
];

export const label = 'Company';
